// removed by extract-text-webpack-plugin
module.exports = {"main":"XwO3EdJinpo0frhKtrNkg"};


//////////////////
// WEBPACK FOOTER
// ./components/Forgot.module.css
// module id = 2353
// module chunks = 1